import { PayloadAction } from '@reduxjs/toolkit'

import { RequestStatus } from 'clickNgo/configs/service/common'

import { TExecutableTransitions } from '../../api/OnboardingActionApi'
import { IExecutableTransitionParams, IOnboardingState } from '../models'

export const getExecutableTransitionPending = (
  state: IOnboardingState,
  action: PayloadAction<unknown, string, { arg: IExecutableTransitionParams }>
) => {
  const { meta } = action

  state.executableTransitionData.meta = meta
  state.executableTransitionData.status = RequestStatus.PENDING
  state.executableTransitionData.message = ''
}

export const getExecutableTransitionRejected = (
  state: IOnboardingState,
  action: PayloadAction<unknown, string, { arg: IExecutableTransitionParams }>
) => {
  const { meta } = action

  state.executableTransitionData.meta = meta
  state.executableTransitionData.status = RequestStatus.REJECTED
  state.executableTransitionData.message = action.payload as string
}

export const getExecutableTransitionFulfilled = (
  state: IOnboardingState,
  action: PayloadAction<TExecutableTransitions | null, string, { arg: IExecutableTransitionParams }>
) => {
  const { meta, payload } = action

  state.executableTransitionData.meta = meta
  state.executableTransitionData.status = RequestStatus.FULFILLED
  state.executableTransitionData.message = ''
  if (payload) {
    state.executableTransitionData.data = payload
  }
}
